/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAccountDeleteMutation($customerAccountId: ID!) {
  CustomerAccountDelete(customerAccountId: $customerAccountId) {
    id
    message
    status
  }
}
`
